import { useEffect, useState } from "react";
import { AuthTokenRetrieve, LoginButton } from "./AuthTokenRetrieve";

const PrivateSectionGate = (props) => {
  const { title, description, children, className = "" } = props;
  const [shouldShow, setShouldShow] = useState(false);
  const { shouldShow: hasPrivateAccess } = AuthTokenRetrieve();

  useEffect(() => {
    setShouldShow(hasPrivateAccess);
  }, [hasPrivateAccess]);

  if (!shouldShow) {
    return (
      <div className={`searchBarDiv formViewWrapper PrivateAccessGate ${className}`.trim()}>
        <h2>{title}</h2>
        <p>{description}</p>
        <LoginButton setShouldShow={setShouldShow}></LoginButton>
      </div>
    );
  }

  return children;
};

export default PrivateSectionGate;
